import React from 'react';
import { CheckCircle2Icon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { offer } from '../data/offer';
const HERO_BG = 'https://cdn.magicpatterns.com/patterns/generated-images/114e7f7c-b720-45ba-a9d4-04559571f636.jpg';
const BUNDLE = 'https://cdn.magicpatterns.com/patterns/generated-images/7c87cbfb-8768-40a4-91ec-b470735828d0.jpg';
interface HeroProps {
  variant: 'stadium' | 'bundle';
}

/** Staggered CSS entrance — no animation library needed. */
const step = (i: number) => ({
  animationDelay: `${i * 60}ms`
});
function TrustRow() {
  return <ul className="flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-white/70" style={{
    paddingTop: "0px",
    paddingBottom: "0px"
  }} data-id="element-81" data-mp="sb1chsl5257m">
      <li className="flex items-center gap-2" data-id="element-82" data-mp="nboo33emcq2x">
        <span className="flex" aria-hidden="true" data-id="element-83" data-mp="3d1a99mbhsfec">
          {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-sun text-sun" data-id="element-84" data-mp="3cz5uuafyvxzt" />)}
        </span>
        <span data-id="element-85" data-mp="3814ehx9xecs1">
          <span className="font-semibold text-white" data-id="element-86" data-mp="384s4img5wh20">{offer.satisfaction}</span> সন্তুষ্টির হার
        </span>
      </li>
      <li className="flex items-center gap-2" data-id="element-87" data-mp="3o7bzrwu0yng3">
        <CheckCircle2Icon className="h-4 w-4 text-celeste-400" aria-hidden="true" data-id="element-88" data-mp="3o73ouahgps7j" />
        বাংলাদেশের {offer.studentCount} শিক্ষার্থী
      </li>
      <li className="flex items-center gap-2" data-id="element-89" data-mp="3e9607lvoxtee">
        <CheckCircle2Icon className="h-4 w-4 text-celeste-400" aria-hidden="true" data-id="element-90" data-mp="3e84rvp627l0d" />
        ৭ দিনের মানি-ব্যাক গ্যারান্টি
      </li>
    </ul>;
}
function HeroCopy({
  centered
}: {
  centered: boolean;
}) {
  return <div className={centered ? 'max-w-4xl' : 'max-w-xl'} data-id="element-91" data-mp="35a2gcfop99yu">
      <p className="rise text-[11px] font-semibold uppercase tracking-[0.22em] text-celeste-400" style={{
      fontSize: "16px",
      paddingTop: "0px",
      paddingBottom: "0px",
      textAlign: "center",
      ...step(0)
    }} data-id="element-92" data-mp="2qkmrx6cn5gmb">
          KODA ☀ DIGITAL
      </p>

      <h1 className="rise mt-5 font-display text-[2.15rem] font-extrabold leading-[1.03] tracking-tight text-white sm:text-5xl lg:text-[3.5rem]" style={step(1)} data-id="element-93" data-mp="2lkqyu25hf9lj">
        <span className="block text-celeste-400" data-id="element-94" data-mp="s3mbny4btqw9">দুই দেশ, এক আত্মা:</span>
        <span className="block text-celeste-400" data-id="element-95" data-mp="naa1gt0e9mn1">সেই গোপন মাইন্ডসেট</span>
        <span className="block text-white" data-id="element-96" data-mp="ibyowaipsy14">যা কষ্টকে বদলে দেয়</span>
        <span className="block text-white" style={{
        paddingTop: "0px",
        paddingBottom: "0px"
      }} data-id="element-97" data-mp="ia5kz2zhkrwt">বিশ্বজয়ী সাফল্যে</span>
        <span className="mt-4 block text-[1.3rem] font-bold leading-snug text-celeste-400 sm:text-3xl lg:text-[2rem]" data-id="element-98" data-mp="1b1fd0vzaxsrj">
          <span className="block" style={{
          paddingTop: "0px",
          paddingBottom: "0px",
          marginTop: "0px",
          marginBottom: "0px"
        }} data-id="element-99" data-mp="162uc0uc87521">দশকের পর দশক আর্জেন্টিনা ও বাংলাদেশ</span>
          <span className="block" data-id="element-100" data-mp="x0l3ub4fjnrt">একেবারে তলা থেকে লড়ে এসেছে।</span>
        </span>
      </h1>

      <figure className="rise mx-auto mt-8 w-full max-w-sm sm:max-w-md lg:max-w-lg" style={step(2)} data-id="element-101" data-mp="3luia4t2z73mf">
        <img src="https://cdn.magicpatterns.com/uploads/1F54PG35zgk9PPm7PMfsdP/hf_20260828_232444_4091d97d-8cc8-4515-9b4a-3185bb5c24c9.png" alt="দ্য আর্জেন্টাইন মাইন্ডসেট সম্পূর্ণ ডিজিটাল সিস্টেম: ছয়টি ভলিউম, মূল বই, বোনাস কালেকশন এবং ট্যাব ও ফোনে দেখানো কনটেন্ট — বুয়েনস আইরেস ও ঢাকার রাতের স্কাইলাইনের পটভূমিতে" width={1024} height={1024} decoding="async" fetchPriority="high" className="h-auto w-full rounded-xl border border-white/15" style={{
        paddingTop: "0px",
        paddingBottom: "0px",
        marginTop: "0px",
        marginBottom: "0px"
      }} data-id="element-102" data-mp="3hpsen5c8br21" />
      </figure>

      <p className="rise mt-6 max-w-2xl text-lg leading-relaxed text-white/75 sm:text-xl" style={{
      fontSize: "14px",
      paddingTop: "0px",
      paddingBottom: "0px",
      marginTop: "9px",
      marginBottom: "9px",
      width: "328px",
      height: "120px",
      ...step(3)
    }} data-id="element-103" data-mp="2kxkktl39ksv9">
        আবিষ্কার করুন সেই নির্দিষ্ট মাইন্ডসেট পরিবর্তন, যা আর্জেন্টিনাকে দারিদ্র্য থেকে
        বিশ্বচ্যাম্পিয়ন বানিয়েছে — আর <span className="font-semibold text-white" data-id="element-104" data-mp="zlswhq2zfz8k">আজই</span> কীভাবে
        সেটি আপনার ব্যবসা, ফ্রিল্যান্স ক্যারিয়ার বা ব্যক্তিগত উন্নতিতে কাজে লাগাবেন (আগে
        ব্যর্থ হলেও)।
      </p>

      <div className="rise mt-9" style={step(4)} data-id="element-105" data-mp="3vh5m6d05fiad">
        <CtaButton size="lg" href="#volumes" label="আমি সম্পূর্ণ বিষয়বস্তু দেখতে চাই।" sublabel="সাথে সাথেই অ্যাক্সেস · ৭ দিনের মানি-ব্যাক গ্যারান্টি" data-id="element-106" data-mp="e9a8c8r1p6n9" />
      </div>

      <div className="rise mt-9 border-t border-white/10 pt-6" style={{
      paddingTop: "0px",
      paddingBottom: "0px",
      ...step(5)
    }} data-id="element-107" data-mp="98e4fv6p1khu">
        <TrustRow data-id="element-108" data-mp="3cryzyg05c8jt" />
      </div>
    </div>;
}
export function Hero({
  variant
}: HeroProps) {
  if (variant === 'bundle') {
    return <header className="relative overflow-hidden bg-navy-950" data-id="element-109" data-mp="3rhn21jg5jb8l">
        <div className="mx-auto grid max-w-content items-center gap-14 px-4 py-20 sm:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:py-28" data-id="element-110" data-mp="3motzn285oezo">
          <HeroCopy centered={false} data-id="element-111" data-mp="2yy80k0g4q51t" />
          <div className="relative" data-id="element-112" data-mp="2u0pow2aq9bq4">
            <img src={BUNDLE} alt="The six volumes of The Argentine Mindset shown as ebook covers and on a tablet" width={1024} height={768} decoding="async" loading="lazy" className="relative h-auto w-full rounded-2xl border border-white/10 object-cover" data-id="element-113" data-mp="2u1hi56guqxd8" />
          </div>
        </div>
      </header>;
  }
  return <header className="relative isolate overflow-hidden bg-navy-950" data-id="element-114" data-mp="zliye7b2l5lg">
      <img src={HERO_BG} alt="" aria-hidden="true" decoding="async" fetchPriority="low" className="absolute inset-0 h-full w-full object-cover opacity-80" data-id="element-115" data-mp="14j16xwl6disx" />
      <div className="absolute inset-0 bg-navy-950/55" aria-hidden="true" data-id="element-116" data-mp="1s9ybgoan5du5" />
      <div className="relative mx-auto max-w-content px-4 py-24 sm:px-6 lg:py-32" style={{
      paddingTop: "8px",
      paddingBottom: "8px"
    }} data-id="element-117" data-mp="1x6x2uz2x76on">
        <HeroCopy centered data-id="element-118" data-mp="1na26omu4didj" />
      </div>
    </header>;
}